import { Package, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * List of available (broadcast) orders the courier can pick up.
 */
export const AvailableOrdersList = ({ orders, onAccept, visible }) => {
  if (!visible) return null;
  return (
    <Card className="mb-8 shadow-lg bg-[#0F172A] border-white/10">
      <CardHeader>
        <CardTitle
          className="flex items-center gap-2 text-white font-black uppercase tracking-widest text-base"
          data-testid="available-orders-title"
        >
          <Package className="w-5 h-5 text-[#D4AF37]" />
          Commandes disponibles ({orders.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {orders.length === 0 ? (
          <p className="text-center text-slate-300 font-bold py-8">
            Aucune commande disponible pour le moment
          </p>
        ) : (
          <div className="space-y-4">
            {orders.map((order) => (
              <div
                key={order.id}
                className="border-2 border-white/10 rounded-2xl p-5 bg-[#0F172A] hover:border-[#D4AF37]/40 transition-all"
                data-testid={`available-order-${order.id}`}
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <p className="text-base font-black text-white">
                      #{order.id.substring(0, 8)}
                    </p>
                    <p className="text-[10px] font-black uppercase tracking-widest text-[#D4AF37]">
                      {order.order_type}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-black text-emerald-400">
                      +{order.courier_earning} FCFA
                    </p>
                    <p className="text-xs text-slate-300 font-bold">{order.distance_km} km</p>
                  </div>
                </div>

                <div className="space-y-2 mb-4">
                  <div className="flex items-start gap-2 bg-[#003594]/15 border border-[#003594]/30 rounded-xl p-3">
                    <MapPin className="w-4 h-4 text-[#D4AF37] mt-1 flex-shrink-0" />
                    <div className="min-w-0">
                      <p className="text-[10px] text-[#D4AF37] font-black uppercase tracking-widest">
                        Départ
                      </p>
                      <p className="text-base font-black text-white leading-snug">
                        {order.pickup_address}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2 bg-emerald-500/15 border border-emerald-500/30 rounded-xl p-3">
                    <MapPin className="w-4 h-4 text-[#D4AF37] mt-1 flex-shrink-0" />
                    <div className="min-w-0">
                      <p className="text-[10px] text-[#D4AF37] font-black uppercase tracking-widest">
                        Arrivée
                      </p>
                      <p className="text-base font-black text-white leading-snug">
                        {order.delivery_address}
                      </p>
                    </div>
                  </div>
                </div>

                <Button
                  onClick={() => onAccept(order.id)}
                  className="w-full bg-gradient-to-r from-[#003594] to-[#D4AF37] hover:opacity-90 text-white rounded-full font-semibold"
                  data-testid={`accept-order-${order.id}`}
                >
                  ✓ Accepter cette livraison
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
